import lowerCase from "lodash/lowerCase";
import toString from "lodash/toString";
import type { IServiceAdapter } from "../adapter/GTMServiceExtendedAdapter";
import type { GTM } from "./GTMInterfaces";

interface IBuildGtmItem {
  fromService(service: IServiceAdapter): GTM.Item;
}

export class BuildGtmItem implements IBuildGtmItem {
  constructor(private itemListId: string) {}

  private getItemListId() {
    return lowerCase(this.itemListId);
  }

  private getItemListName() {
    return toString(this.itemListId);
  }

  public fromService(service: IServiceAdapter): GTM.Item {
    const itemId = service.getUniqueId();
    const itemName = service.getName();
    const currency = service.getCurrency();
    const discount = service.getDiscount();
    const index = service.getIndex();
    const brand = service.getBrand();
    const category = service.getCategory();
    const itemListId = this.getItemListId();
    const itemListName = this.getItemListName();
    const price = service.getPrice();
    const quantity = service.getQuantity();

    return {
      item_id: itemId,
      item_name: itemName,
      currency,
      discount,
      index,
      item_brand: brand,
      item_category: category,
      item_list_id: itemListId,
      item_list_name: itemListName,
      price,
      quantity,
    };
  }
}
